import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { LinkObject, MenuTopic } from '../../types/topics';
import TopicsItem from './TopicsItem';

type Props = {
  menuTopics: MenuTopic[];
  onSelectTopic?: (topic: LinkObject) => void;
};
/** TopicsColumn wrapper for SearchMenu. */
const TopicsColumn = (props: Props) => {
  const { menuTopics, onSelectTopic } = props;

  return (
    <>
      <Flex className="flex-col flex-1 mx-3" data-testid="topics-column">
        {menuTopics.map((menu: MenuTopic, i: number) => (
          <TopicsItem
            onSelectTopic={onSelectTopic}
            dataTestId={`${i}_block_${menu?.path}`}
            key={menu?.path}
            item={menu}
          />
        ))}
      </Flex>
    </>
  );
};

export default TopicsColumn;
